<div class="top-vendors">
  <div class="header">
    <div class="navigation">
      <h2 class="top-vendors-text">{{ pageTitle }}</h2>
      <div (click)="navigateToVendorsList()">
        <emerald-icon
          [icon]="'open_in_new'"
          [color]="priority.grey"
          [fontsizeInRem]="fontSize_opentab"
        >
        </emerald-icon>
      </div>
    </div>
    <div>
      <emerald-dropdown
        [options]="monthDropdownOptions"
        [id]="'month_select'"
        [outlined]="true"
        [isValid]="true"
        [label]="'Month'"
        [(ngModel)]="selectedOption"
        (onChange)="onMonthChange($event)"
      ></emerald-dropdown>
    </div>
  </div>
  <div *ngIf="!isLoading" class="top-vendor-chart">
    <ng-container *ngIf="isDataLoaded && chartData.length > 0; else noDataTemplate">
      <div class="vendor-summary">
        <span class="summary-value">{{ totalVendorCount }}</span>
        <span class="summary-label">TOTAL CONTRACTORS</span>
      </div>
      <ul class="vendor-rank-list">
        <li class="vendor-rank-row" *ngFor="let vendor of rankedVendors; let i = index" [attr.title]="vendor.name">
          <span class="rank-index" [style.background-color]="vendor.color">{{ i + 1 }}</span>
          <div class="rank-bar-wrap">
            <div class="rank-row-top">
              <span class="rank-name">{{ vendor.name }}</span>
              <span class="rank-count">{{ vendor.count }}</span>
            </div>
            <div class="rank-track">
              <div class="rank-fill" [style.width.%]="vendor.widthPct" [style.background-color]="vendor.color"></div>
            </div>
          </div>
        </li>
      </ul>
    </ng-container>

    <ng-template #noDataTemplate>
      <section class="records-container" aria-label="Records section">
        <div class="empty-state">
          <h2 class="empty-state-title">{{ errorMessage }}</h2>
          <img
            [src]="imageSrc"
            alt="No records illustration"
            class="empty-state-image"
          />
        </div>
      </section>
    </ng-template>
  </div>
</div>
